import { inject, Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { LocalStorage } from "@shared/enums";
import { RecentEmulates } from "@home/models/recent-emulates";
import { MemberInfoResponse, RequestState, SentinelProfileResponse } from "@shared/models";
import { GlobalService, MemberInfoService, SentinelProfileService } from "@shared/services";

@Injectable({
  providedIn: "root",
})
export class AdminService {
  globalService = inject(GlobalService);
  sentinelProfileService = inject(SentinelProfileService);
  memberInfoService = inject(MemberInfoService);

  getStatusDetails(): { key: string; label: string }[] {
    return [
      { key: "base", label: "Base" },
      { key: "position", label: "Seat" },
      { key: "equipment", label: "Equip" },
    ];
  }

  getCompanyDetails(): { key: string; label: string }[] {
    return [
      { key: "employeeNumber", label: "Emp ID" },
      { key: "seniority", label: "Seniority" },
    ];
  }

  initEmulatedUserProfile(emulatedUser: string): Observable<RequestState<SentinelProfileResponse>> {
    this.globalService.emulatedUser.set(emulatedUser);
    return this.sentinelProfileService.getSentinelProfile(false, emulatedUser);
  }

  getRecentEmulates(): RecentEmulates[] {
    const recentEmualtes = localStorage.getItem(LocalStorage.RecentEmulates);
    return recentEmualtes ? JSON.parse(recentEmualtes) : [];
  }

  emulateUser(emulatedUser: string | null): Observable<RequestState<SentinelProfileResponse>> {
    if (emulatedUser) {
      this.globalService.emulatedUser.set(emulatedUser);
      localStorage.setItem(LocalStorage.EmulatedUser, emulatedUser);
      this.storeRecentEmulates(emulatedUser);
      return this.sentinelProfileService.getSentinelProfile(false, emulatedUser);
    }
    return {} as Observable<RequestState<SentinelProfileResponse>>;
  }

  stopEmulation(): void {
    this.removeCachedEmulatedData(this.globalService.emulatedUser());
    this.globalService.emulatedUser.set("");
  }

  getMemberInfo(): Observable<RequestState<MemberInfoResponse>> {
    return this.memberInfoService.getMemberInfo(
      this.globalService.emulatedUser(),
      this.globalService.authedToken().apaempid
    );
  }

  private storeRecentEmulates(emulatedUser: string): void {
    const recentEmulatedArray: RecentEmulates[] = JSON.parse(localStorage.getItem(LocalStorage.RecentEmulates) || "[]");

    const currentDate = new Date()
      .toLocaleDateString("en-GB", { day: "2-digit", month: "short" })
      .toUpperCase()
      .replace(" ", "");

    const updatedArray = [
      { employee: emulatedUser, date: currentDate },
      ...recentEmulatedArray.filter((emulate) => emulate.employee !== emulatedUser),
    ];

    localStorage.setItem(LocalStorage.RecentEmulates, JSON.stringify(updatedArray.slice(0, 10)));
  }

  private removeCachedEmulatedData(emulatedUser: string | null): void {
    if (emulatedUser) {
      localStorage.removeItem(LocalStorage.EmulatedUser);
      Object.keys(localStorage).forEach((key) => {
        if (key.endsWith(emulatedUser)) {
          localStorage.removeItem(key);
        }
      });
    }
  }
}
